import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import Casinos from "../pages/casinos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/casinos",
    element: <Casinos />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
